import { type Extension } from '@tiptap/core';

import { createProviderPastePlugin } from './createProviderPastePlugin';
import { extractNotionPageId, isNotionUrl } from './notion-url';

export type NotionPasteResult = {
  url: string;
  pageId: string;
};

export const extractNotionFromPaste = (
  text: string,
): NotionPasteResult | undefined => {
  const trimmed = text.trim();
  if (!trimmed || /\s/.test(trimmed)) return undefined;
  if (!isNotionUrl(trimmed)) return undefined;
  const pageId = extractNotionPageId(trimmed);
  if (!pageId) return undefined;
  return { url: trimmed, pageId };
};

export const createNotionPastePlugin = (
  onPastedRef: React.RefObject<((result: NotionPasteResult) => void) | null>,
): Extension =>
  createProviderPastePlugin('notionPaste', extractNotionFromPaste, onPastedRef);
